var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 571 c-9 -15 3 -31 24 -31 14 0 29 -28 64 -122 25 -68 48 -131 52 -140 5 -13 2 -18 -9 -18 -22 0 -56 -36 -56 -60 0 -11 9 -29 20 -40 11 -11 20 -29 20 -40 0 -26 34 -60 60 -60 25 0 60 34 60 59 0 16 8 20 38 23 25 2 37 8 37 18 0 12 -19 16 -95 20 -76 4 -95 8 -95 20 0 13 27 15 170 18 93 1 173 6 177 10 12 13 49 255 40 264 -5 5 -85 7 -178 6 -142 -3 -169 -5 -169 -18 0 -13 25 -15 156 -18 l156 -2 -16 -98 -17 -97 -125 -3 -125 -3 -60 158 c-58 155 -60 158 -91 161 -17 2 -34 -2 -38 -7z m191 -442 c10 -17 -13 -36 -27 -22 -12 12 -4 33 11 33 5 0 12 -5 16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 160 c-11 -11 -20 -29 -20 -40 0 -11 9 -29 20 -40 11 -11 29 -20 40 -20 26 0 60 34 60 60 0 26 -34 60 -60 60 -11 0 -29 -9 -40 -20z m56 -31 c10 -17 -13 -36 -27 -22 -12 12 -4 33 11 33 5 0 12 -5 16 -11z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.6773cadb8aab06cf0efc7a52f1d5f64e.svg";
export { ForwardRef as ReactComponent };